import {SuiDropdownModule, SuiPopupModule} from '@angular-ex/semantic-ui';
import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';

import {LOCALES} from '../../../core/constants';
import {clientRoles} from '../../../core/constants/client-roles.config';
import {clients} from '../../../core/constants/clients.config';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SuiDropdownModule,
    RouterLink,
    RouterLinkActive,
    SuiPopupModule,
  ],
})
export class NavigationBarComponent implements OnInit {
  protected keycloakService = inject(KeycloakService);

  // constants
  public clientRoles = clientRoles;
  public userRoles: string[] = [];

  protected readonly LOCALES = LOCALES;

  ngOnInit() {
    this.userRoles = this.keycloakService.getUserRoles(false, clients.API);
  }
}
